export default __webpack_public_path__ + "media/images/favicon/favicon-96-8190cc8dbdd8541a7f0c483209194290.png";